/**
 * 统一简体中文文案（zh-CN）
 * 按命名空间分组：common / member / cancel / permission / user / privacy
 * 其它语言在同级 en.js / ja.js 等只写差异键，缺失自动回退此处。
 *
 * 所有协议均采用「模板占位 + 多语言文案」结构：
 *   - user    → src/agreements/user/template.js（用户协议，文字提取至下方 user 命名空间，用 {{user.xxx}} 占位符）
 *   - privacy → src/agreements/privacy/template.js（隐私政策，文字提取至下方 privacy 命名空间，用 {{privacy.xxx}} 占位符）
 * 下方保留带 {{占位符}} 的 common/member/cancel/permission/user/privacy 等命名空间。
 */
export default {
  common: {
    // 多公司（品牌）分组：qy = 轻语Ai，cm = 蚕猫ai，sf = 树帆科技，umeipires = umeipires，sjxf = 时间小方
    // URL 参数 ?appname=xxx 切换，可匹配的名称见 src/config/brands.js 的 brandAliases；未匹配时默认 qy
    // 新增公司：复制一份分组并填字段，留空的字段自动回退 qy
    qy: {
      appName: '轻语Ai',
      companyName: '深圳数芯语科技有限公司',
      contactEmail: 'market@nihaoxiaozhi.com',
      contactAddress: '深圳市光明区凤凰街道塘尾社区明湖智谷产业园6栋1002',
      appFeedback: '登录产品界面 → 点击「联系我们」'
    },
    cm: {
      appName: '蚕猫ai',
      // TODO: 补充蚕猫ai 的主体信息，留空字段自动回退 qy
      companyName: '',
      contactEmail: '',
      contactAddress: '',
      appFeedback: ''
    },
    sf: {
      appName: '树帆科技',
      companyName: '襄阳树帆教育科技有限公司',
      contactEmail: 'shufanxiaoke@163.com',
      contactAddress: '湖北省襄阳市枣阳市南城中兴大道1号枣阳数字经济产业园三楼A366',
      appFeedback: '登录产品界面 → 点击「联系我们」'
    },
    umeipires: {
      appName: 'umeipires',
      // TODO: 补充 umeipires 的主体信息，留空字段自动回退 qy
      companyName: '',
      contactEmail: '',
      contactAddress: '',
      appFeedback: ''
    },
    sjxf: {
      appName: '时间小方',
      companyName: '深圳市绿巨能科技发展有限公司',
      contactEmail: 'luozhilin@nllano.cn',
      contactAddress: '深圳市龙华新区民治街道民乐工业园B栋203',
      appFeedback: '登录产品界面 → 点击「联系我们」'
    }
  },
  member: {
    titleSuffix: '会员服务协议',
    subtitle: '感谢您选择我们的会员服务，请仔细阅读以下条款，注册即表示您同意接受全部协议内容。',
    benefitsTitle: '会员权益说明',
    card1Title: '会员卡权益',
    card1_li1: '模型特权：畅享更高级的问答模型无限使用特权，拥有更长的记忆对话。',
    card1_li2: '轻语对话：让心灵的交流不受限制、轻触心灵的每一个细节。',
    card1_li3: '轻语专享：享受更自然、更亲密的对话体验、让温暖常伴左右。',
    card1_li4: '专属会员：优先踏上新功能的探索之旅，成为时尚科技的前沿弄潮儿。',
    card2Title: '音色卡权益',
    card2_li1: '音色畅享：解锁海量音色，让对话更加丰富多彩。',
    card2_li2: '优先特权：优先体验上新音色，成为引领声音潮流的先锋达人。',
    card2_li3: '独特音色：定制专属您的独特音色，展现个性魅力，让您与众不同。',
    card3Title: '音乐卡权益',
    card3_li1: '畅听无阻：海量歌曲等您搜索，享受高品质音乐的纯粹体验。',
    card3_li2: '个性推荐：个性化音乐推荐，轻松找到您喜爱的歌曲。',
    card3_li3: '歌单词库：专属类目歌单，与音乐歌词共同狂欢。',
    card4Title: '新人专享套餐',
    card4_li1: '三效合一：一份套餐同时享有对话音色（音色卡）、高级AI模型（会员卡）与音乐曲库（音乐卡）三重权益。',
    card4_li2: '新人专享：仅限新注册用户购买，每个账号限购一次。',
    termsTitle: '会员服务协议条款',
    term1Title: '服务条款',
    term1_1: '1.1 本协议是用户（以下简称"您"）与{{common.companyName}}之间就使用会员服务所订立的协议。您通过网络页面点击确认或以其他方式选择接受本协议，即表示您同意接受本协议的全部条款和条件。',
    term1_2: '1.2 {{common.companyName}}有权根据业务发展需要对服务内容、服务价格、服务期限等进行调整，并以适当方式通知您。您若继续使用服务，即视为同意接受调整后的内容。',
    term2Title: '会员权益',
    term2_1: '2.1 会员卡：您可根据自身需求选择不同类型的会员卡，每种会员卡对应不同的服务内容和价格。具体以{{common.companyName}}官方公布的信息为准。',
    term2_2: '2.2 服务期限：会员服务期限以您实际购买的服务套餐为准，自购买成功并激活之日起计算。',
    term2_3: '2.3 服务变更：在服务期限内，{{common.companyName}}可能会对会员服务内容进行优化或调整，以提升服务质量和用户体验。',
    term3Title: '费用与支付',
    term3_1: '3.1 会员服务费用将根据您选择的会员类型和服务期限确定，具体金额以支付页面显示为准。',
    term3_2: '3.2 您可以选择适合的支付方式进行支付，支付成功后，服务将立即生效。',
    term3_3: '3.3 除非法律法规另有规定或本协议另有约定，会员服务费用一经支付，不予退还。',
    term4Title: '用户权利与义务',
    term4_1: '4.1 您有权在服务期限内按照本协议约定使用相应的会员服务。',
    term4_2: '4.2 您应遵守本协议及{{common.companyName}}制定的相关规则，不得利用会员服务从事任何违法、违规或侵犯他人权益的活动。',
    term4_3: '4.3 您应妥善保管您的账号和密码，不得将账号共享或转让给他人使用。因您保管不善导致的损失由您自行承担。',
    term5Title: '隐私保护',
    term5_1: '5.1 {{common.companyName}}尊重并保护您的隐私，将按照{{common.companyName}}的隐私政策收集、使用和保护您的个人信息。',
    term5_2: '5.2 您同意{{common.companyName}}在提供服务过程中可能会收集和使用您的相关信息，包括但不限于使用记录、设备信息等。',
    term6Title: '协议变更',
    term6_1: '{{common.companyName}}有权随时修改本协议的条款，修改后的协议将通过适当方式通知您。',
    footerRights: '保留所有权利',
    footerPrivacy: '隐私政策',
    footerTerms: '服务条款'
  },

  cancel: {
    title: '注销须知',
    important1: '重要提示：在您注销账号之前，请阅读、理解并同意如下事项：',
    important2: '特别提示：注销账号是不可恢复的操作。注销后，您将无法使用本账号，也无法找回因注销、删除而被删除或匿名化的任何内容或信息（即使您使用相同的手机号重新注册并使用本产品）。{{common.appName}}账号指您依据由{{common.companyName}}运营的《{{common.appName}}用户协议》所创建，供您作为注册用户登录并使用本产品及服务的凭证。',
    p1: '请您确保申请注销的账号是您依据《{{common.appName}}用户协议》创建并提供给我们的账号。您应按照我们规定的程序或网站上的提示进行上述账号的注销。',
    p2: '在注销账号之前，您应自行备份与该账号相关的所有信息和数据，并确认与该账号相关的所有服务均已妥善处理。注销完成后，我们将删除您的个人信息或对其进行匿名化处理（法律法规另有规定的除外）。',
    p3: '我们深表遗憾您做出注销账号的决定。如果您仍决定继续进行账号注销，您的账号必须同时符合以下条件：',
    cond1Title: '账号处于安全状态',
    cond1: '该账号处于正常使用中，且通过平台安全检查，不存在被盗、违规或封禁等风险。通过先进的安全监测系统，我们会实时监控账号的登录行为和操作记录，确保账号未被异常登录或用于任何违反平台规则的活动。例如，若发现账号异地登录或进行了异常频繁的敏感操作，将视为不符合安全状态条件，无法注销。',
    cond2Title: '账号财产已结清、交易已完结',
    cond2: '该账号下所有相关的资产、预期收益及权益均已结清、退款、清空或自愿放弃。这包括但不限于您已购买的付费充值、虚拟物品或服务，以及您在本平台进行的各类交易。我们会仔细核对您账号下的每一笔交易记录，确保不存在未结清的费用、未完结的退款流程或未处理完毕的权益。例如，若您购买了某项增值服务且服务期限尚未届满，但您决定注销账号，我们会确认您是否已获取该对应服务的全部权益，或是否已按规定申请并办理了合理的退款。只有当与账号关联的所有财务事宜均已妥善解决，才满足此注销条件。',
    cond3Title: '账号权限已释放',
    cond3: '该账号已解除与其他产品的授权登录或绑定关系。在您使用{{common.appName}}的过程中，您可能曾与其他第三方产品/服务进行过授权登录或绑定操作。在注销账号前，您需要确保上述所有关联关系均已解除。我们会与相关第三方系统进行数据交互验证，确认该账号不再与其他外部产品存在授权关系。例如，若您曾使用{{common.appName}}账号登录过某第三方阅读应用，并授予该应用某些访问权限，那么在注销{{common.appName}}账号时，您需要先在该第三方应用中取消对{{common.appName}}账号的授权，否则无法完成账号注销流程。',
    cond4Title: '账号无争议',
    cond4: '该账号不存在任何未完成和/或存在争议的服务。账号不存在未解决的争议，包括但不限于被投诉、举报、侵权纠纷等。我们会全面审查您账号的历史记录，排查是否存在用户间的纠纷、投诉或举报，以及是否涉及侵权等情况。例如，若您因不当言论或行为被其他用户投诉，或者您投诉了其他用户的某些行为侵犯了您的权益，在这些争议妥善解决之前，该账号无法注销。只有当账号处于无争议状态时，方可进入下一步注销环节。',
    conseqTitle: '本账号注销后，您将无法登录、使用本账号，包括但不限于：',
    conseq1: '您将无法在本产品中登录、使用该账号。这是注销账号最直接的结果，注销完成后，系统会彻底清除该账号相关的登录凭证和权限信息，您将无法再通过此账号访问{{common.appName}}的任何功能或服务。',
    conseq2: '您将无法找回您输入、上传或接收回复的任何内容或信息。一旦账号注销，与之相关的所有交互数据，包括您提出的问题、上传的文件、与{{common.appName}}的对话记录以及接收到的回复内容等，都将被删除或匿名化处理，无法找回。请您在注销前谨慎考虑是否需要保留这些重要信息。',
    conseq3: '您将无法找回该账号相关的账号内任何内容或信息，包括账号的个人资料和历史信息（含账户资料信息及操作信息等）。这涵盖了您注册账号时填写的个人信息，如昵称、头像、联系方式等，以及您使用过程中的所有操作记录，如登录时间、浏览历史、设置变更等。这些信息将随着账号的注销而永久丢失，无法恢复。',
    p4: '在账号注销期间，若您的账号涉及争议，包括但不限于：投诉、举报、诉讼、仲裁、被国家主管机关调查等，您理解并同意{{common.appName}}有权决定是否终止本账号的注销而无需再取得您的另行授权。这是为了维护平台的正常运营秩序以及保障用户权益。在账号注销过程中，若出现任何可能影响平台规则执行或涉及其他用户权益的争议情况，我们会根据具体情况进行判断。例如，若您的账号因严重违规行为被其他用户投诉，且投诉正在调查阶段，为了确保调查的公正性和有效性，我们有权暂停该账号的注销流程，直至争议解决。在争议妥善解决后，我们会根据最终结果决定是否继续该账号的注销操作。',
    p5: '注销本账号不代表您注销前的行为和相关责任得以免除或减轻。即使账号已注销，您在使用{{common.appName}}服务期间产生的任何行为及责任，仍受相关法律法规及平台规则的约束。例如，若您在账号注销前违反了《{{common.appName}}用户协议》的某些条款，如发布违法违规内容、侵犯他人知识产权等，我们仍有权依据相关规定追究您的责任。您需对账号注销前的一切行为和决定承担全部法律后果，账号注销不能成为逃避责任的途径。',
    p6: '请在做出谨慎的注销账号决定前，仔细阅读并充分理解以上全部条款。若您确认符合上述所有条件并决定注销账号，请按照我们规定的程序或网站上的提示进行操作。如您有任何疑问，欢迎随时联系我们的客服团队，我们将竭诚为您解答。'
  },

  permission: {
    title: '应用权限申请与使用情况说明',
    androidTitle: '一、Android 操作系统申请权限列表',
    androidCardTitle: 'CAMERA',
    cardDescLabel: '权限功能说明',
    androidCardDesc: '使用相机拍摄照片、视频',
    cardUseLabel: '使用场景或用途',
    androidCardUse: '用于帮助您完成拍摄、发送图片等功能',
    iosTitle: '二、iOS 操作系统申请权限列表',
    iosCardTitle: 'NSCameraUsageDescription',
    iosCardDesc: '使用相机',
    iosCardUse: '用于帮助您完成拍摄、发送图片等功能',
    thirdPartyTitle: '三、第三方 SDK 及第三方开发的 H5 页面或小程序申请的权限',
    sdkTitle: '（一）第三方 SDK 申请的权限',
    sdkPermTitle: '1. 权限申请',
    sdkPerm1: '网络权限（INTERNET）：用于与第三方服务器通信以获取必要的数据或服务，确保 SDK 正常运行。例如，一些用于提供广告服务的 SDK 需要联网获取广告素材并展示信息。',
    sdkPerm2: '存储权限（READ_EXTERNAL_STORAGE、WRITE_EXTERNAL_STORAGE）：部分 SDK 可能需要读取或写入外部存储权限，以存储或获取相关数据。例如，用于缓存应用数据的 SDK 可能需要写入存储权限来保存临时文件。',
    sdkPerm3: '设备信息权限（如 READ_PHONE_STATE）：获取相关设备信息，如设备型号、IMEI 号等，以便 SDK 能根据设备特征提供更合适的服务或进行统计分析。',
    sdkUseTitle: '2. 用途说明',
    sdkUse1: '我们引入第三方 SDK 是为了增强{{common.appName}}的功能，如提供更丰富的内容推荐、广告投放管理、性能监控等服务。使用这些 SDK 是为了实现产品的特定业务功能，我们会尽合理努力确保第三方在利用您的个人信息时遵循合法、正当、必要原则。',
    sdkUse2: '例如，广告 SDK 用于在产品中展示相关广告，以支撑产品的运营和发展，但不会收集与广告展示无关的个人信息。性能监控 SDK 有助于我们了解产品在不同设备上的运行情况，从而及时优化性能，提升您的体验，同样不会过度收集您的个人信息。',
    sdkListTitle: '3. 第三方 SDK 列表',
    sdkList1: 'APP 支付客户端 SDK（包名：com.alipay.sdk）：由支付宝（杭州）信息技术有限公司开发，收集支付订单信息、设备标识符、网络信息，用于实现支付功能。',
    sdkList2: '微信开放 SDK（包名：com.tencent.mm.opensdk）：由深圳市腾讯计算机系统有限公司开发，收集微信用户标识、设备标识符、网络信息，用于实现微信登录与分享功能。',
    h5Title: '（二）第三方开发的 H5 页面或小程序申请的权限',
    h5PermTitle: '1. 权限申请',
    h5Perm1: '位置权限（ACCESS_FINE_LOCATION、ACCESS_COARSE_LOCATION）：若 H5 页面或小程序提供基于位置的服务，如附近信息查询、本地生活服务推荐等，可能会申请位置权限以获取您的地理位置信息。',
    h5Perm2: '麦克风权限（RECORD_AUDIO）：在一些需要进行语音交互或语音识别功能的 H5 页面或小程序中，可能会申请麦克风权限，以实现语音输入和交互功能。',
    h5UseTitle: '2. 用途说明',
    h5Use1: '这些第三方开发的 H5 页面或小程序申请权限是为了实现其自身的特定业务功能。我们会对其进行一定的审核和管理，但无法完全控制其权限使用行为。',
    h5Use2: '例如，与位置相关的 H5 页面或小程序旨在为您提供更贴合本地需求的服务，方便您查找附近的商家、活动等信息。而具备语音交互功能的 H5 页面或小程序，是为了让您更便捷地与其交流，无需手动输入文字。建议您谨慎使用这些 H5 页面或小程序，并注意保护个人信息安全。若发现其存在不合理的权限申请或使用行为，请及时通过本政策第九章所述方式与我们联系。',
    manageTitle: '四、权限管理说明',
    openCloseTitle: '（一）权限开启与关闭',
    cameraTitle: '1. 相机权限',
    camera1: '相机权限默认不开启，仅在您明确授权后才用于实现特定功能或服务，您也可撤回授权。',
    camera2: '您可以在设备自身的操作系统中关闭相机权限，以更改同意的范围或撤回您的授权。具体操作方法如下：',
    cameraStepsLabel: '',
    cameraStepAndroid: 'Android：系统设置 - 应用设置 - 应用管理 - 搜索或找到{{common.appName}} - 权限管理 - 选择对应权限 - 关闭',
    cameraStepIos: 'iOS：系统设置 - {{common.appName}} - 选择对应权限 - 关闭',
    camera3: '请注意，具体的关闭方式可能因您的设备型号和系统版本而有所不同。当您进行上述操作时，我们将无法继续为您提供与撤回同意或授权相对应的服务，也不再收集与这些权限相关的信息，但不会影响此前基于您的授权已开展的个人信息的处理。',
    otherTitle: '2. 其他权限',
    other1: '对于其他可能涉及如网络、存储、设备信息等权限，您也可以根据上述类似的系统设置路径进行管理。例如，若您想关闭网络权限，可在安卓系统的设置中找到应用网络管理选项，对{{common.appName}}进行设置；在 iOS 系统中，可在设置的蜂窝网络或无线局域网选项中调整{{common.appName}}的网络使用权限。',
    other2: '您有权根据自身需求随时开启或关闭这些权限，以控制个人信息的收集和使用。我们尊重您的自主选择权，致力于为您提供清晰便捷的权限管理方式，让您更好地保护个人信息安全。',
    changeTitle: '（二）权限变更通知',
    change1: '随着产品功能的不断更新和扩展，我们可能会根据实际情况调整权限的申请和使用。如有变更，我们将按照法律法规的要求，通过以下方式及时告知您：',
    changeStep1: '应用内提示：在{{common.appName}}应用内的显著位置弹出提示框，详细说明权限变更的内容、原因及对您的影响。',
    changeStep2: '推送通知：向您的设备发送推送消息，提醒您关注权限变更。推送内容将简要告知您权限调整的关键信息。',
    changeStep3: '更新本应用权限申请与使用情况说明：及时更新本文档，并通过应用内帮助中心、公告栏等渠道向您展示最新的权限申请和使用说明，确保您能全面了解相关变更。',
    change2: '我们将确保您能及时、准确地知悉权限变更情况，以便您做出合理的决策。在进行权限变更前，我们会充分考虑对您个人信息保护的影响，尽量减少不必要的权限申请。若您对权限变更有任何疑问或担忧，请随时与我们联系，我们将竭诚为您解答，并根据您的合理要求进行处理。',
    otherTitle2: '五、其他说明',
    otherInfo1: '我们重视您对个人权限的控制。如果您对应用权限有任何疑问或担忧，请随时与我们联系。我们将通过以下方式为您提供帮助：',
    otherOnline: '在线客服：您可以通过{{common.appName}}应用内的在线客服入口随时与我们的客服人员沟通，他们将为您解答关于应用权限的问题。',
    otherEmail: '客服邮箱：您也可以发送邮件至我们的客服邮箱{{common.contactEmail}}，详细描述您的问题，我们将在收到邮件后的[X]个工作日内回复。',
    otherFeedback: '反馈渠道：此外，您还可以通过{{common.appName}}应用内的专属反馈渠道提交您的意见和建议，我们会认真对待每一条反馈，并及时处理您关于应用权限的关切。',
    otherInfo2: '我们将持续优化产品的权限管理机制，在满足产品功能和安全需求的同时，最大程度地保障您的个人信息安全和隐私。我们会定期审查和评估应用权限的使用情况，不断改进权限申请和使用的合理性和必要性。如果您发现任何异常的权限申请或使用行为，请立即告知我们，我们将及时进行调查和处理。',
    otherInfo3: '通过上述对应用权限申请和使用的详细说明，我们希望您能更清晰地了解{{common.appName}}及相关第三方在权限方面的操作，从而更好地保护您的个人信息和隐私。我们将一如既往地致力于为您提供安全、便捷、优质的产品和服务体验。'
  },

  privacy: {
    titleSuffix: '隐私政策',
    p0001: "{{common.appName}}隐私政策",
    p0002: "{{common.appName}}隐私政策",
    p0003: "更新日期：2025年10月21日",
    p0004: "《{{common.appName}}隐私政策》（以下称“本政策”）适用于{{common.companyName}}（以下简称“我们”）推出的人工智能服务（以下简称“{{common.appName}}”或“本服务”）。您在使用本服务前，请仔细阅读本政策，以了解我们处理您个人信息的详情。",
    p0005: "除非本隐私政策另有说明，本隐私政策适用于我们提供的{{common.appName}}网页、应用程序、小程序、供第三方网站和应用程序使用的软件开发工具包（SDK）和应用程序编程接口（API）以及随着技术发展出现的创新形态方式提供的产品和服务。如您使用我们公司向您提供的智能体的某项或某几项服务，有其单独的隐私政策的，则相应服务或产品适用相应隐私政策；如未设立单独隐私政策的，则本政策同样适用于该部分产品或服务。",
    p0006: "请您知悉，终端用户访问开发者使用我们的开放平台服务开发的下游系统或应用时，其被收集的个人信息的处理规则不在本隐私政策的说明范围内，运营该应用的开发者作为该个人信息处理活动的处理者应当向终端用户披露相关个人信息保护规则。",
    p0007: "当您使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除非是为实现业务功能或根据法律法规要求所必需的必要信息，您均可以拒绝提供且不影响其他功能或服务。我们将在隐私政策中逐项说明所要收集的信息。",
    p0008: "相机权限均不会默认开启，只有经过您的明示授权才会在为实现特定功能或服务时使用，您也可以撤回授权。特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。具体请参见：应用权限申请与使用情况说明。",
    p0009: "下文将帮您详细了解我们如何收集、使用、存储、转移（如适用）与保护个人信息；帮您了解查询、复制、删除、更正、撤回授权个人信息的方式。本政策与您使用我们的服务关系密切，我们建议您仔细阅读并理解本政策全部内容，作出您认为适当的选择，有关您个人信息权益的条款重要内容我们已用加粗形式提示，请特别关注。",
    p0010: "个人信息处理总则",
    p0011: "为保障您的知情权、决定权与个人信息权益，我们在此集中说明本服务涉及的个人信息处理核心规则。您可结合后续章节详细了解具体场景：",
    p0012: "1. 处理目的",
    p0013: "我们处理您的个人信息主要用于以下目的：",
    p0014: "提供、维护和优化{{common.appName}}智能对话、账号管理、付费服务等核心功能；",
    p0015: "履行国家法律法规关于网络实名制、网络安全、内容安全等法定义务；",
    p0016: "保障系统与账号安全，防范欺诈、滥用及违法违规行为；",
    p0017: "在经严格去标识化且无法重新识别特定个人的前提下，用于大模型训练、服务优化与统计分析；",
    p0018: "向您发送服务通知、身份验证信息及经您同意的商业推广信息。",
    p0019: "2. 处理方式",
    p0020: "我们通过加密传输（TLS/SSL）、访问控制、去标识化、匿名化、日志审计等技术和管理措施处理个人信息，确保数据安全，防止未经授权的访问、泄露、篡改或丢失。",
    p0021: "3. 个人信息类型",
    p0022: "我们可能处理的个人信息包括但不限于：",
    p0023: "账号信息：",
    p0024: "手机号码、第三方账号昵称/头像；",
    p0025: "身份认证信息：",
    p0026: "真实姓名、身份证件号码（仅限实名认证场景）；",
    p0027: "输入与输出内容：您在对话中输入的文本、图片、文件，以及{{common.appName}}生成的响应内容；",
    p0028: "设备与日志信息：",
    p0029: "IP地址、设备型号、操作系统版本、设备标识符（如AndroidID、IDFV）、网络状态、操作行为日志、传感器数据；",
    p0030: "支付信息：订单号、交易金额、支付渠道、充值记录；",
    p0031: "反馈与客服信息：问题描述、联系方式、沟通记录、附件材料。",
    p0032: "4. 保存期限",
    p0033: "我们仅在实现处理目的所必需的最短期间内保存您的个人信息，具体如下：",
    p0034: "账号信息：账号存续期间；",
    p0035: "对话输入与输出：默认保留至您主动删除或注销账号；",
    p0036: "网络运行日志：不少于6个月（依据《网络安全法》第二十一条）；",
    p0037: "支付与财务信息：依据《会计法》《电子商务法》等规定保存不少于5年；",
    p0038: "您注销账号后，我们将对您的个人信息进行删除或匿名化处理，法律法规另有规定的除外。",
    p0039: "5. 关于模型训练的特别说明",
    p0040: "您的输入内容及对应的输出内容可能被用于{{common.appName}}大语言模型的优化与训练，但前提是：",
    p0041: "已通过安全加密技术处理；",
    p0042: "已进行严格去标识化；",
    p0043: "无法重新识别到您或其他特定个人。",
    p0044: "您有权拒绝该用途。如您不同意我们将您的数据用于模型训练，请通过本政策第九章所述联系方式提出，我们将停止将您的数据用于该目的。",
    p0045: "6. 您的权利",
    p0046: "根据《中华人民共和国个人信息保护法》，您依法享有以下权利：",
    p0047: "知情权与决定权；",
    p0048: "限制或拒绝他人对您个人信息的处理；",
    p0049: "查阅、复制您的个人信息；",
    p0050: "更正、补充不准确或不完整的个人信息；",
    p0051: "删除您的个人信息；",
    p0052: "撤回已作出的授权同意；",
    p0053: "注销账号；",
    p0054: "要求将您的个人信息转移至您指定的其他处理者（在技术可行范围内）；",
    p0055: "对个人信息处理规则要求解释说明；",
    p0056: "向监管部门投诉或提起诉讼。",
    p0057: "具体行使方式详见本政策第六章。",
    p0058: "7. 第三方共享与委托处理",
    p0059: "除为提供服务所必需（如云服务商、支付机构、实名认证机构、安全审计方）或履行法定义务外，我们不会向其他第三方共享您的个人信息。所有合作方均须签署数据处理协议，并接受我们的安全监督。如涉及跨境传输，将另行征得您的单独同意。",
    p0060: "一、我们如何收集和使用您的个人信息",
    p0061: "账号注册、登录、认证",
    p0062: "为保障您的个人空间使用安全，您需要注册并登录后方可正常使用相关服务。您在注册和登录时需要向我们提供您本人的手机号码并设置登录密码，并且通过输入验证码，以便我们对您的用户身份进行核验。手机号码是履行国家法律法规关于网络实名制要求的必要信息，如果您不提供手机号码用于注册、登录，我们可能无法为您提供生成式人工智能技术服务。",
    p0063: "您可以使用第三方账号登录并使用{{common.appName}}，经过您的同意，我们将获取您在第三方平台注册的公开信息（头像、昵称以及您授权的其他信息），用于与{{common.appName}}账号绑定，使您可以直接登录并使用本产品和相关服务。",
    p0064: "在您使用{{common.appName}}开放平台的付费服务时，我们需要对您的身份进行认证。您可以选择认证为个人账号或者代表企业认证为企业账号。根据相关法律法规，当您选择认证为个人开发者时，我们可能收集您的真实身份信息（真实姓名、证件号码、电话号码及其他必要身份信息）以完成实名验证；当您代表企业认证为企业开发者时，我们可能会收集您所在企业法定代表人、企业联系人的真实姓名以完成企业实名验证。部分信息属于个人敏感信息，您可以拒绝提供，如果拒绝提供您将可能无法获得相关服务，但不影响其他功能与服务的正常使用。",
    p0065: "智能对话",
    p0066: "在您使用智能对话功能服务时，我们将收集您与{{common.appName}}进行交互过程中所输入的内容（包括文本、图片、文件），我们会对上述信息进行分析与计算，以便于更好地理解您的问题和上下文语境，从而为您提供更具有相关性的信息内容，以提供智能对话服务。",
    p0067: "当您主动拍摄时，我们会请求您授权相机权限。如您拒绝授权，将无法拍摄图片信息，但不影响您使用{{common.appName}}的其他功能。当您使用搜索服务时，我们会自动接收您主动输入的信息，以便向您自动提供实时搜索结果。",
    p0068: "在对话过程中，您可以对{{common.appName}}所输出的内容进行反馈评价。我们将收集您的反馈信息，包括您主动提交的内容，以便不断改进{{common.appName}}的输出内容质量。如您拒绝我们收集和处理前述个人信息，请您谨慎输入前述信息，但因此您可能会影响您正常使用{{common.appName}}提供的部分或全部功能。",
    p0069: "为向您提供连续、高质量的服务，在经安全加密技术处理、严格去标识化且无法重新识别特定个人的前提下，我们可能会将服务所收集的输入内容及对应输出的内容，用于{{common.appName}}服务质量的提升和优化。如您拒绝我们按照上述方式处理您的个人信息，可以通过本政策第九章的方式向我们反馈。",
    p0070: "付费充值",
    p0071: "您可以就付费服务对您认证账号下的账户进行预充值，当您使用付费服务进行预充值时，我们会收集您的支付订单和交易信息，以为您提供充值订单的下单、支付、客服及售后等服务，并向您展示和提供具体的付费服务。",
    p0072: "支付服务",
    p0073: "为完成订单支付，您可通过与我们合作的支付机构（包括支付宝、微信支付及其他页面提供的支付方式）所提供的服务进行支付。我们会在您使用支付服务过程中收集您的账号信息、订单支付相关信息及其他法律要求的必要信息并与支付机构共享，以确认您的支付指令并帮助您完成支付。支付机构还可能自行或委托我们收集或验证您的银行卡（含储蓄卡、信用卡）信息以及其他支付必要信息。",
    p0074: "意见反馈",
    p0075: "如您使用意见反馈功能服务时，我们会收集您的问题描述信息、证明材料附件、手机号码、邮箱、联系人姓名，以了解您反馈的内容和需求。此类信息属于意见反馈功能服务的必要信息。为了核实您的身份，明确您的需求和相关问题的处理方案，或帮助您解决其他问题，我们可能会使用您的手机号码或邮箱。为了向您提供与您使用过程信息相关的意见反馈服务时，我们将会查询您的使用信息，包括对话记录、点赞记录、问题反馈记录。",
    p0076: "如您直接通过本政策第九章所述的方式与我们联系，提出意见反馈，进行投诉、申诉或咨询{{common.appName}}的相关问题时，为了确保您的账号与系统的安全，您需要向我们提供您的账号信息，以便我们对您的用户身份进行核验，此类信息属于用户反馈中进行身份核验的必要信息。在反馈、投诉或咨询过程中，为了帮助您解决问题或记录相关问题的处理方案及结果，您可能需要向我们提供相应的证明材料附件，系统可能会记录您与我们之间的沟通记录，以便能够更好地帮您解决所咨询的问题和改善服务质量。如您不提供上述信息，我们可能无法向您及时反馈咨询的结果，但不影响您正常使用{{common.appName}}或服务。",
    p0077: "消息通知",
    p0078: "您知悉并同意，对于您在使用产品及/或服务的过程中提供的您的联系方式（例如：联系电话），我们在运营中可能会向其中的一种或多种发送多类通知，用于用户消息告知、身份验证、安全验证、用户使用体验调研、争议处理等用途；此外，我们也可能会向前述过程中收集的手机号码以短信、电话的方式，为您提供服务、功能或活动等商业性信息，但请您放心，如您不愿接受这些信息，您可以通过手机短信中提供的退订方式进行退订（如回复“R”，具体参考短信提供的方式），也可以直接与我们联系进行退订。",
    p0079: "运营与安全保障",
    p0080: "为了保障您的账号安全和更好地为您提供优质的服务，我们会自动收集您在使用{{common.appName}}服务过程中产生的如下信息作为网络日志：",
    p0081: "为了保障软件与服务的安全运行、运营的质量及效率，我们会收集您的硬件型号、操作系统版本号、设备标识符（Android如AndroidID、OAID，iOS如IDFV；不同的标识符在有效期、是否可由用户重置以及获取方式方面会有所不同）、IP 地址、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、设备传感器数据（如加速度传感器、陀螺仪传感器）。",
    p0082: "为了预防恶意程序、保障运营质量及效率，我们可能会收集正在运行的进程信息、页面的总体运行、使用情况与频率、页面崩溃情况、总体使用情况、性能数据。为了判断账户及交易安全、进行身份验证、识别违法违规情况、检测及防范安全事件，并依法采取必要的记录、分析、处置措施，我们可能使用您的账户信息、设备信息以及服务日志信息。",
    p0083: "为了分析应用新增、激活、留存、性能等统计性指标，我们可能会调用剪切板对相关统计信息进行归因分析。请您放心，在统计过程中，我们不会上传您的任何隐私信息至我们的服务器。",
    p0084: "我们可能会使用上述网络日志信息以便我们统计{{common.appName}}的使用情况，进行问题排查，并通过数据统计进行运营分析、改进和优化产品交互体验。",
    p0085: "收集、使用个人信息的其他规则",
    p0086: "请您了解，随着我们业务的发展，可能会对功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次按照法律法规及国家标准的要求以页面提示、交互流程、协议确认方式另行向您进行告知说明，并征得您的同意。",
    p0087: "请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息不必事先征得您的授权同意：",
    p0088: "与我们履行法律法规规定的义务所必需的；",
    p0089: "与国家安全、国防安全直接相关的；",
    p0090: "维护公共安全、公共卫生、重大公共利益所必需的；",
    p0091: "与刑事侦查、起诉、审判和判决执行等直接相关的；",
    p0092: "出于维护您或他人的生命、财产等重大合法权益所必需但又很难得到本人授权同意的；",
    p0093: "您自行向社会公众公开的个人信息；",
    p0094: "根据个人信息主体要求签订和履行合同所必需的；",
    p0095: "从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；",
    p0096: "为开展合法的新闻报道所必需的；",
    p0097: "法律法规规定的其他情形。",
    p0098: "特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时，或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。",
    p0099: "二、我们如何使用Cookie等同类技术",
    p0100: "Cookie技术的使用",
    p0101: "我们会通过cookies收集和使用您的信息，并将该等信息储存为日志信息。我们使用自己的cookies，目的是用于以下用途：",
    p0102: "记住您的身份。例如：cookies有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的其他信息；",
    p0103: "分析您使用我们服务的情况。例如，我们可利用cookies来了解您使用我们的服务进行什么活动； 我们为上述目的使用cookies的同时，可能将通过cookies收集的非个人身份信息，经统计加工后提供给或其他合作伙伴，用于分析用户如何使用我们的服务。",
    p0104: "Cookie同类技术的使用",
    p0105: "我们会使用的Cookie同类技术包括：网站信标和像素标签。我们使用上述同类技术的目的是了解您的产品或服务偏好并改善客户服务。",
    p0106: "Cookie的清除",
    p0107: "大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。如您进行清除，因为这些修改，您可能无法使用依赖于cookies的服务或相应功能。",
    p0108: "三、我们如何委托处理、共享、转让、公开披露您的个人信息",
    p0109: "数据共享的原则",
    p0110: "合法原则： 与合作方合作过程中涉及数据使用活动的，必须具有合法目的、符合法定的合法性基础。如果合作方使用信息不再符合合法原则，则其不应再使用您的个人信息，或在获得相应合法性基础后再行使用。",
    p0111: "正当与最小必要原则： 数据使用必须具有正当目的，且应以达成目的必要为限。",
    p0112: "安全审慎原则： 我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序编程接口（API）进行严格的安全监测，以保护数据安全。",
    p0113: "对于委托处理个人信息的场景，我们会与受托合作方根据法律规定签署相关处理协议，并对其个人信息使用活动进行监督。",
    p0114: "对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。",
    p0115: "实现功能或服务的数据使用",
    p0116: "当您使用{{common.appName}}中由我们的合作方提供的功能，或者由软件服务提供商、智能设备提供商、系统服务提供商与我们联合为您提供的服务时，我们可能会与其使用为实现业务目的所必需的信息。",
    p0117: "在您使用身份认证的功能或相关服务所需时，根据相关法律法规、安全保障要求可能需要完成实名认证以验证您的身份。在实名认证的过程中，与我们合作的认证服务机构需要使用您的真实姓名、手机号码。部分信息是个人敏感信息，拒绝上述使用将导致您无法完成身份认证，且可能无法获得相关服务，但不会影响开放平台其他功能的正常使用。这些信息仅供实名认证及法律法规所规定的用途，未经您的明示授权，不会用作其他目的。",
    p0118: "实现推广业务的数据使用",
    p0119: "为实现产品推广以及相关分析服务，并优化与提升推广的有效触达率，产品的推广方或提供推广以及相关分析服务的合作方可能需要使用去标识化或匿名化后的设备、网络、渠道信息以及转化数据等。",
    p0120: "推广合作方可能将上述信息与其合法获取的其他数据相结合，以优化推广效果，我们会要求其对信息的使用遵循合法、正当、必要原则，保障用户合法权利不受侵犯。",
    p0121: "实现安全与分析统计而提供信息",
    p0122: "保障使用安全：我们非常重视账号、服务及内容安全。为保障您和其他用户的账号与财产安全，使您和我们的正当合法权益免受不法侵害，我们的合作方可能会使用必要的设备、账号及日志信息。",
    p0123: "分析产品情况：为分析我们产品的使用和表现情况，我们的合作方可能需要使用该产品使用情况（崩溃、闪退）、设备标识信息、应用总体安装使用情况等信息。",
    p0124: "转移",
    p0125: "随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方继续履行个人信息处理者的义务，若继受方变更原先的处理目的、处理方式的，我们将要求继受方重新征得您的授权同意。",
    p0126: "公开",
    p0127: "我们不会公开您的个人信息，除非遵循国家法律法规规定或者获得您的同意。我们公开您的个人信息会采用符合行业内标准的安全保护措施。",
    p0128: "在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。",
    p0129: "如果我们确定您出现违反法律法规或严重违反本产品相关协议规则的情况，或为保护本产品及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或本产品相关协议规则披露关于您的个人信息，包括相关违规行为以及本产品已对您采取的措施。",
    p0130: "委托处理、共享、转让、公开披露个人信息时事先征得授权同意的例外",
    p0131: "以下情形中，委托处理、共享、转让、公开披露您的个人信息无需事先征得您的授权同意：",
    p0132: "我们履行法律法规规定的义务所必需的；",
    p0133: "与国家安全、国防安全直接相关的；",
    p0134: "维护公共安全、公共卫生、重大公共利益所必需的；",
    p0135: "刑事侦查、起诉、审判和判决执行等所必需的；",
    p0136: "出于维护您或他人的生命、财产等重大合法权益所必需但又很难得到本人授权同意的；",
    p0137: "您自行向社会公众公开的个人信息；",
    p0138: "根据个人信息主体要求签订和履行合同所必需的；",
    p0139: "从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；",
    p0140: "为开展合法的新闻报道所必需的；",
    p0141: "法律法规规定的其他情形。",
    p0142: "请您知悉：根据法律规定，委托处理、共享、转让及公开披露经匿名化处理的个人信息的，不属于个人信息的对外委托处理、共享、转让及公开披露的处理行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。",
    p0143: "四、我们如何保护您的个人信息",
    p0144: "用户的隐私和个人信息保护",
    p0145: "我们非常重视用户的隐私和个人信息保护，也会采取合理的措施保护用户的个人信息。除法律法规规定或本政策另有约定的情形外，我们将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。未经用户许可我们不会向第三方公开、透露用户个人信息，我们会对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。",
    p0146: "数据安全措施",
    p0147: "我们已采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。",
    p0148: "我们已采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。",
    p0149: "互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。",
    p0150: "在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件发生的原因、可能造成的危害、涉及个人信息的种类、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议和可采取的措施等。我们将及时将事件相关情况以电子邮件、短信、电话、发送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。请您知悉，根据可适用法律法规的规定，如采取措施能够有效避免信息泄露、篡改、丢失造成危害的，我们可以不向您进行告知。",
    p0151: "五、我们如何存储您的个人信息",
    p0152: "存储信息的地点",
    p0153: "{{common.appName}}遵守法律法规的规定，收集的有关您的信息和资料将保存在中华人民共和国境内大陆地区{{common.appName}}的服务器上。以下情形除外：",
    p0154: "法律法规有明确规定；",
    p0155: "获得您的明确授权；",
    p0156: "您通过互联网进行跨境交易等个人主动行为。",
    p0157: "存储信息的期限",
    p0158: "我们仅在为提供{{common.appName}}服务之目的所必需的期间内保留您的个人信息：例如：",
    p0159: "手机号码：当您使用手机号码注册登录时，我们需要持续保留您的手机号码，以便于向您提供正常的服务、应对您可能的查询和客诉，并保障您的账号和系统安全。",
    p0160: "您的付费充值等相关信息，在您未撤回、删除或未注销账号期间，我们会保留相关信息用于向您提供持续的业务功能。",
    p0161: "如果您注销账号、主动删除个人信息或超出必要的期限后，我们将对您的个人信息进行删除或匿名化处理，但以下情况除外：",
    p0162: "遵从法律法规有关信息留存的要求（例如：《网络安全法》规定：采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月）。",
    p0163: "出于财务、审计、争议解决等目的需要合理延长期限的。",
    p0164: "当本服务发生停止运营的情形时，{{common.appName}}将采取包括发送通知和公告形式通知您，并在法律法规要求的期限内删除服务器中留存的您的个人信息。",
    p0165: "六、您如何实现管理您个人信息的权利",
    p0166: "您的个人信息权利",
    p0167: "按照中国相关的法律、法规、标准，您在个人信息处理活动中享有若干权利，具体包括：",
    p0168: "您对个人信息处理享有知情权、决定权，有权限制或者拒绝他人对您个人信息进行处理，法律、行政法规另有规定的除外；",
    p0169: "您有权向个人信息处理者查阅、复制您的个人信息，法律另有规定情形的除外；",
    p0170: "您有权请求将您的个人信息转移至您指定的个人信息处理者；",
    p0171: "您发现您的个人信息不准确或不完整的，有权请求个人信息处理者更正、补充；",
    p0172: "您有权请求删除您的个人信息；",
    p0173: "您有权要求个人信息处理者对其个人信息处理规则进行解释说明。",
    p0174: "行使权利的方式",
    p0175: "我们保障您对自己的个人信息行使前述权利，并为您提供相关操作路径，具体地，您可以参考以下步骤进行相关操作：",
    p0176: "改变或撤回授权范围",
    p0177: "您可以在设备本身的操作系统中，关闭相机权限，改变同意范围或撤回您的授权。",
    p0178: "具体地，您可以通过以下方式进行操作：",
    p0179: "安卓：系统设置 → 应用设置 → 应用管理 → 搜索或查找{{common.appName}} → 权限管理 → 选择对应权限 → 关闭",
    p0180: "iOS：系统设置 → {{common.appName}} → 选择对应权限 → 关闭",
    p0181: "请您知悉，具体的关闭方式可能因您使用设备型号、系统版本的不同而不尽相同。请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，我们将不再收集与这些权限相关的信息，但不会影响此前基于您的授权而开展的个人信息处理。",
    p0182: "查阅、复制、更正、补充、删除您的个人信息",
    p0183: "您可以通过如下方式查阅、复制、更正、补充或删除您的个人信息：",
    p0184: "查阅/更正/补充账号信息：点击头像账号区域，进行操作",
    p0185: "查阅/删除历史对话：展开对话框左侧 → 选择历史对话 → 删除，或点击头像账号区域 → 选择“删除所有对话”",
    p0186: "复制/修改历史对话：选择对话框内的输入内容 → 复制/修改",
    p0188: "由于应用版本的升级和功能的变动，上述具体的操作步骤可能不同，以应用内实际的操作步骤为准。除上述外，如果您或其他有权主体对相关法律法规赋予您的个人信息权利的行使，有任何主张、要求或者疑问，您可以通过本政策第九章的联系方式与我们联系，我们将尽快审核所涉问题，并在验证您的用户身份后的十五个工作日内回复。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，{{common.appName}}可能会予以拒绝。",
    p0189: "逝者的个人信息保护",
    p0190: "我们会持续确保我们的用户信息安全无虞。若{{common.appName}}的用户不幸去世，其近亲属（以下简称“逝者近亲属”）为了自身的合法、正当利益，可通过本隐私政策第九章列明的方式，与我们取得联系，在不违反逝者生前安排且不侵害他人和公众正当利益的前提下，对逝者的相应个人信息行使查阅、复制、更正、删除等权利。为了充分保护逝者的个人信息权益，申请行使该等权利的逝者近亲属需要完成身份核验手续，并承诺和保证逝者近亲属行使该等权利不违背逝者生前的安排，且行使权利的目的具有合法正当性。",
    p0191: "注销账号",
    p0192: "您有权根据《{{common.appName}}注销须知》注销您的账号，您可以通过“主页” → “个人信息” → “注销账号”或根据本政策第九章所述的方式联系我们进行账号注销。在您注销账号前，我们将验证您的个人身份、安全状态、财产结清情况、设备信息等。我们将会在收到您的申请后及时进行处理，并在十五个工作日或法律法规要求的时限内回复您的请求。您知悉并理解，注销账号的行为是不可逆的行为，当您注销账号后，我们将删除有关您的相关信息或进行匿名化处理，但法律法规及相关国家标准另有规定的除外。",
    p0193: "七、我们如何保护未成年人的个人信息",
    p0194: "{{common.appName}}主要服务成年人，但我们依然非常重视对未成年人个人信息的保护。",
    p0195: "若您是未满18周岁的未成年人，在使用本产品及相关服务前，请在您的父母或其他监护人的监护、指导下共同阅读并同意本隐私政策。我们不会主动收集未满14周岁的未成年人（儿童）的个人信息。如果我们发现或接到反馈，在未事先获得监护人同意的情况下自动收集了儿童的个人信息，则会设法尽快删除相关信息。",
    p0196: "若您是未成年人的父母或监护人，如您对本政策所述相关事宜有任何疑问、意见、建议或投诉、举报需求，请通过第九章所述方式与我们进行反馈。",
    p0197: "八、我们如何更新本政策",
    p0198: "为给您提供更好的服务，{{common.appName}}将不时更新与变化，我们会适时对本政策进行修订，这些修订构成本政策的一部分。",
    p0199: "本政策更新后，我们会在{{common.appName}}网站发出更新版本，通过新版本公告等方式再次提醒您阅读更新后的隐私政策，以便您及时了解本政策的最新版本。如果您不同意本政策，或对本政策修改、更新的内容有异议，您可以选择停止使用本服务或者注销账号。但请您知悉，您账号注销之前、停止使用本服务之前的行为和活动仍受本政策的约束。",
    p0200: "对于会导致您在本个人信息保护规则项下权利的实质减损的重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于电子邮件、短信或在浏览页面做特别提示等方式，说明本政策的具体变更部分）。",
    p0201: "我们鼓励您在使用我们产品与/或服务的过程中查阅本政策。",
    p0202: "九、如何联系我们",
    p0203: "如您在使用{{common.appName}}的过程中对本政策或对您的个人信息有任何疑问或建议，请通过以下联系方式与我们联系：",
    p0204: "网络自助投诉反馈入口：登录产品界面 → 点击“联系我们”按钮",
    p0205: "联系邮箱：{{common.contactEmail}}",
    p0206: "{{common.companyName}}",
    p0207: "我们可能需要您提交有效联系方式和书面请求及相关证据，我们会在验证您的身份后处理您的请求。我们将尽快审核所涉问题，并在验证您的用户身份后的十五个工作日内回复。",
  },

  user: {
    titleSuffix: '用户协议',
    u0001: "{{common.appName}}隐私政策与用户协议",
    u0003: "{{common.appName}}隐私政策与用户协议",
    u0004: "更新日期：2026年6月30日",
    u0005: "亲爱的用户，欢迎您使用{{common.appName}}产品及服务！{{common.appName}}产品及服务由{{common.companyName}}（以下简称“我们”）负责运营。本文件包含《{{common.appName}}隐私政策》（以下称“本政策”）与《{{common.appName}}用户协议》（以下称“本协议”），共同适用于我们推出的人工智能服务（以下称“{{common.appName}}”或“本服务”），包括网页、应用程序、小程序、SDK、API 及随技术发展出现的其他形态。",
    u0006: "在使用本服务前，请您务必仔细阅读并理解本文件全部内容。您在使用某一特定功能时，针对该功能可能另有单独协议或业务规则（以下称“具体协议”）；本文件与具体协议冲突的，以具体协议为准。所有前述条款构成本文件不可分割的组成部分（通称“全部协议”），具有同等法律效力。",
    u0007: "我们特别提醒您在使用本服务前认真阅读（未满18周岁的未成年人应在法定监护人陪同下阅读）、充分理解全部条款，尤其是加粗显示及个人信息相关条款。当您点击确认、勾选同意或实际使用本服务时，即表示您已接受全部协议约束。若您不同意任一内容，请停止使用本服务。",
    u0008: "下文将说明我们如何收集、使用、存储、共享与保护个人信息，以及您使用本服务应遵守的规则。有关个人信息权益的重要条款已加粗提示，请特别关注。终端用户访问开发者基于我们开放平台开发的下游应用时，其个人信息处理规则由该应用开发者另行向用户披露。",
    u0009: "相机等敏感权限均不会默认开启，仅在经您明示授权且为实现特定功能所必需时使用，您也可随时撤回授权。",
    u0010: "个人信息处理总则",
    u0011: "为保障您的知情权、决定权与个人信息权益，我们在此集中说明本服务涉及的个人信息处理核心规则。您可结合后续章节详细了解具体场景：",
    u0012: "1. 处理目的",
    u0013: "我们处理您的个人信息主要用于以下目的：",
    u0014: "提供、维护和优化{{common.appName}}智能对话、账号管理、付费服务等核心功能；",
    u0015: "履行国家法律法规关于网络实名制、网络安全、内容安全等法定义务；",
    u0016: "保障系统与账号安全，防范欺诈、滥用及违法违规行为；",
    u0017: "在经严格去标识化且无法重新识别特定个人的前提下，用于大模型训练、服务优化与统计分析；",
    u0018: "向您发送服务通知、身份验证信息及经您同意的商业推广信息。",
    u0019: "2. 处理方式",
    u0020: "我们通过加密传输（TLS/SSL）、访问控制、去标识化、匿名化、日志审计等技术和管理措施处理个人信息，确保数据安全，防止未经授权的访问、泄露、篡改或丢失。",
    u0021: "3. 个人信息类型",
    u0022: "我们可能处理的个人信息包括但不限于：",
    u0023: "账号信息：",
    u0024: "手机号码、第三方账号昵称/头像；",
    u0025: "身份认证信息：",
    u0026: "真实姓名、身份证件号码（仅限实名认证场景）；",
    u0027: "输入与输出内容：您在对话中输入的文本、图片、文件，以及{{common.appName}}生成的响应内容；",
    u0028: "设备与日志信息：",
    u0029: "IP地址、设备型号、操作系统版本、设备标识符（如AndroidID、IDFV）、网络状态、操作行为日志、传感器数据；",
    u0030: "支付信息：订单号、交易金额、支付渠道、充值记录；",
    u0031: "反馈与客服信息：问题描述、联系方式、沟通记录、附件材料。",
    u0032: "4. 保存期限",
    u0033: "我们仅在实现处理目的所必需的最短期间内保存您的个人信息，具体如下：",
    u0034: "账号信息：账号存续期间；",
    u0035: "对话输入与输出：默认保留至您主动删除或注销账号；",
    u0036: "网络运行日志：不少于6个月（依据《网络安全法》第二十一条）；",
    u0037: "支付与财务信息：依据《会计法》《电子商务法》等规定保存不少于5年；",
    u0038: "您注销账号后，我们将对您的个人信息进行删除或匿名化处理，法律法规另有规定的除外。",
    u0039: "5. 关于模型训练的特别说明",
    u0040: "您的输入内容及对应的输出内容可能被用于{{common.appName}}大语言模型的优化与训练，但前提是：",
    u0041: "已通过安全加密技术处理；",
    u0042: "已进行严格去标识化；",
    u0043: "无法重新识别到您或其他特定个人。",
    u0044: "您有权拒绝该用途。如您不同意我们将您的数据用于模型训练，请通过第十六节列明的联系方式提出，我们将停止将您的数据用于该目的。",
    u0045: "6. 您的权利",
    u0046: "根据《中华人民共和国个人信息保护法》，您依法享有以下权利：",
    u0047: "知情权与决定权；",
    u0048: "限制或拒绝他人对您个人信息的处理；",
    u0049: "查阅、复制您的个人信息；",
    u0050: "更正、补充不准确或不完整的个人信息；",
    u0051: "删除您的个人信息；",
    u0052: "撤回已作出的授权同意；",
    u0053: "注销账号；",
    u0054: "要求将您的个人信息转移至您指定的其他处理者（在技术可行范围内）；",
    u0055: "对个人信息处理规则要求解释说明；",
    u0056: "向监管部门投诉或提起诉讼。",
    u0057: "具体行使方式详见第六节。",
    u0058: "7. 第三方共享与委托处理",
    u0059: "除为提供服务所必需或履行法定义务外，我们不会向第三方共享您的个人信息；具体共享原则、第三方 SDK 目录及委托处理规则详见",
    u0060: "第三节",
    u0061: "。",
    u0062: "一、我们如何收集和使用您的个人信息",
    u0063: "账号注册、登录、认证",
    u0064: "为保障您的个人空间使用安全，您需要注册并登录后方可正常使用相关服务。您在注册和登录时需要向我们提供您本人的手机号码并设置登录密码，并且通过输入验证码，以便我们对您的用户身份进行核验。手机号码是履行国家法律法规关于网络实名制要求的必要信息，如果您不提供手机号码用于注册、登录，我们可能无法为您提供生成式人工智能技术服务。",
    u0065: "您可以使用第三方账号登录并使用{{common.appName}}，经过您的同意，我们将获取您在第三方平台注册的公开信息（头像、昵称以及您授权的其他信息），用于与{{common.appName}}账号绑定，使您可以直接登录并使用本产品和相关服务。",
    u0066: "在您使用{{common.appName}}开放平台的付费服务时，我们需要对您的身份进行认证。您可以选择认证为个人账号或者代表企业认证为企业账号。根据相关法律法规，当您选择认证为个人开发者时，我们可能收集您的真实身份信息（真实姓名、证件号码、电话号码及其他必要身份信息）以完成实名验证；当您代表企业认证为企业开发者时，我们可能会收集您所在企业法定代表人、企业联系人的真实姓名以完成企业实名验证。部分信息属于个人敏感信息，您可以拒绝提供，如果拒绝提供您将可能无法获得相关服务，但不影响其他功能与服务的正常使用。",
    u0067: "智能对话",
    u0068: "在您使用智能对话功能服务时，我们将收集您与{{common.appName}}进行交互过程中所输入的内容（包括文本、图片、文件），我们会对上述信息进行分析与计算，以便于更好地理解您的问题和上下文语境，从而为您提供更具有相关性的信息内容，以提供智能对话服务。",
    u0069: "当您主动拍摄时，我们会请求您授权相机权限。如您拒绝授权，将无法拍摄图片信息，但不影响您使用{{common.appName}}的其他功能。当您使用搜索服务时，我们会自动接收您主动输入的信息，以便向您自动提供实时搜索结果。",
    u0070: "在对话过程中，您可以对{{common.appName}}所输出的内容进行反馈评价。我们将收集您的反馈信息，包括您主动提交的内容，以便不断改进{{common.appName}}的输出内容质量。如您拒绝我们收集和处理前述个人信息，请您谨慎输入前述信息，但因此您可能会影响您正常使用{{common.appName}}提供的部分或全部功能。",
    u0071: "为向您提供连续、高质量的服务，在经安全加密技术处理、严格去标识化且无法重新识别特定个人的前提下，我们可能会将服务所收集的输入内容及对应输出的内容，用于{{common.appName}}服务质量的提升和优化。如您拒绝我们按照上述方式处理您的个人信息，可以通过第十六节列明的方式向我们反馈。",
    u0072: "付费充值",
    u0073: "您可以就付费服务对您认证账号下的账户进行预充值，当您使用付费服务进行预充值时，我们会收集您的支付订单和交易信息，以为您提供充值订单的下单、支付、客服及售后等服务，并向您展示和提供具体的付费服务。",
    u0074: "支付服务",
    u0075: "为完成订单支付，您可通过与我们合作的支付机构（包括支付宝、微信支付及其他页面提供的支付方式）所提供的服务进行支付。我们会在您使用支付服务过程中收集您的账号信息、订单支付相关信息及其他法律要求的必要信息并与支付机构共享，以确认您的支付指令并帮助您完成支付。支付机构还可能自行或委托我们收集或验证您的银行卡（含储蓄卡、信用卡）信息以及其他支付必要信息。",
    u0076: "意见反馈",
    u0077: "如您使用意见反馈功能服务时，我们会收集您的问题描述信息、证明材料附件、手机号码、邮箱、联系人姓名，以了解您反馈的内容和需求。此类信息属于意见反馈功能服务的必要信息。为了核实您的身份，明确您的需求和相关问题的处理方案，或帮助您解决其他问题，我们可能会使用您的手机号码或邮箱。为了向您提供与您使用过程信息相关的意见反馈服务时，我们将会查询您的使用信息，包括对话记录、点赞记录、问题反馈记录。",
    u0078: "如您直接通过第十六节列明的方式与我们联系，提出意见反馈，进行投诉、申诉或咨询{{common.appName}}的相关问题时，为了确保您的账号与系统的安全，您需要向我们提供您的账号信息，以便我们对您的用户身份进行核验，此类信息属于用户反馈中进行身份核验的必要信息。在反馈、投诉或咨询过程中，为了帮助您解决问题或记录相关问题的处理方案及结果，您可能需要向我们提供相应的证明材料附件，系统可能会记录您与我们之间的沟通记录，以便能够更好地帮您解决所咨询的问题和改善服务质量。如您不提供上述信息，我们可能无法向您及时反馈咨询的结果，但不影响您正常使用{{common.appName}}或服务。",
    u0079: "消息通知",
    u0080: "您知悉并同意，对于您在使用产品及/或服务的过程中提供的您的联系方式（例如：联系电话），我们在运营中可能会向其中的一种或多种发送多类通知，用于用户消息告知、身份验证、安全验证、用户使用体验调研、争议处理等用途；此外，我们也可能会向前述过程中收集的手机号码以短信、电话的方式，为您提供服务、功能或活动等商业性信息，但请您放心，如您不愿接受这些信息，您可以通过手机短信中提供的退订方式进行退订（如回复“R”，具体参考短信提供的方式），也可以直接与我们联系进行退订。",
    u0081: "运营与安全保障",
    u0082: "为了保障您的账号安全和更好地为您提供优质的服务，我们会自动收集您在使用{{common.appName}}服务过程中产生的如下信息作为网络日志：",
    u0083: "为了保障软件与服务的安全运行、运营的质量及效率，我们会收集您的硬件型号、操作系统版本号、设备标识符（Android如AndroidID、OAID，iOS如IDFV；不同的标识符在有效期、是否可由用户重置以及获取方式方面会有所不同）、IP 地址、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、设备传感器数据（如加速度传感器、陀螺仪传感器）。",
    u0084: "为了预防恶意程序、保障运营质量及效率，我们可能会收集正在运行的进程信息、页面的总体运行、使用情况与频率、页面崩溃情况、总体使用情况、性能数据。为了判断账户及交易安全、进行身份验证、识别违法违规情况、检测及防范安全事件，并依法采取必要的记录、分析、处置措施，我们可能使用您的账户信息、设备信息以及服务日志信息。",
    u0085: "为了分析应用新增、激活、留存、性能等统计性指标，我们可能会调用剪切板对相关统计信息进行归因分析。请您放心，在统计过程中，我们不会上传您的任何隐私信息至我们的服务器。",
    u0086: "我们可能会使用上述网络日志信息以便我们统计{{common.appName}}的使用情况，进行问题排查，并通过数据统计进行运营分析、改进和优化产品交互体验。",
    u0087: "收集、使用个人信息的其他规则",
    u0088: "请您了解，随着我们业务的发展，可能会对功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次按照法律法规及国家标准的要求以页面提示、交互流程、协议确认方式另行向您进行告知说明，并征得您的同意。",
    u0089: "请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息不必事先征得您的授权同意：",
    u0090: "与我们履行法律法规规定的义务所必需的；",
    u0091: "与国家安全、国防安全直接相关的；",
    u0092: "维护公共安全、公共卫生、重大公共利益所必需的；",
    u0093: "与刑事侦查、起诉、审判和判决执行等直接相关的；",
    u0094: "出于维护您或他人的生命、财产等重大合法权益所必需但又很难得到本人授权同意的；",
    u0095: "您自行向社会公众公开的个人信息；",
    u0096: "根据个人信息主体要求签订和履行合同所必需的；",
    u0097: "从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；",
    u0098: "为开展合法的新闻报道所必需的；",
    u0099: "法律法规规定的其他情形。",
    u0100: "特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时，或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。",
    u0101: "二、我们如何使用Cookie等同类技术",
    u0102: "Cookie技术的使用",
    u0103: "我们会通过cookies收集和使用您的信息，并将该等信息储存为日志信息。我们使用自己的cookies，目的是用于以下用途：",
    u0104: "记住您的身份。例如：cookies有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的其他信息；",
    u0105: "分析您使用我们服务的情况。例如，我们可利用cookies来了解您使用我们的服务进行什么活动； 我们为上述目的使用cookies的同时，可能将通过cookies收集的非个人身份信息，经统计加工后提供给或其他合作伙伴，用于分析用户如何使用我们的服务。",
    u0106: "Cookie同类技术的使用",
    u0107: "我们会使用的Cookie同类技术包括：网站信标和像素标签。我们使用上述同类技术的目的是了解您的产品或服务偏好并改善客户服务。",
    u0108: "Cookie的清除",
    u0109: "大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。如您进行清除，因为这些修改，您可能无法使用依赖于cookies的服务或相应功能。",
    u0110: "三、我们如何委托处理、共享、转让、公开披露您的个人信息",
    u0111: "数据共享的原则",
    u0112: "合法原则： 与合作方合作过程中涉及数据使用活动的，必须具有合法目的、符合法定的合法性基础。如果合作方使用信息不再符合合法原则，则其不应再使用您的个人信息，或在获得相应合法性基础后再行使用。",
    u0113: "正当与最小必要原则： 数据使用必须具有正当目的，且应以达成目的必要为限。",
    u0114: "安全审慎原则： 我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序编程接口（API）进行严格的安全监测，以保护数据安全。",
    u0115: "对于委托处理个人信息的场景，我们会与受托合作方根据法律规定签署相关处理协议，并对其个人信息使用活动进行监督。",
    u0116: "对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。",
    u0117: "第三方 SDK 目录",
    u0118: "{{common.appName}} 中部分功能由第三方 SDK 提供，这些 SDK 可能会收集您的个人信息。我们已对合作 SDK 进行安全评估，并",
    u0119: "仅在您点击同意本隐私政策后",
    u0120: "才会初始化相关 SDK 并开始收集信息。我们要求第三方 SDK 遵循合法、正当、必要原则，并采取加密传输等安全措施保护您的个人信息。",
    u0121: "特别说明：",
    u0122: "Android 端为实现设备识别、保障应用基础功能运行及安全防范，应用会通过移动安全联盟（MSA）设备标识 SDK 获取 OAID、VAID、AAID 等设备匿名标识符。上述标识符由设备系统或 MSA SDK 在本地读取，",
    u0123: "仅在您同意本隐私政策后",
    u0124: "才会被调用；我们不会超出本政策声明的目的和范围使用这些信息。",
    u0125: "MSA 移动安全联盟设备标识 SDK",
    u0126: "第三方名称",
    u0127: "中国信息通信研究院（移动安全联盟 MSA）",
    u0128: "使用目的",
    u0129: "获取设备匿名标识符，用于保障应用基础功能运行、设备识别、安全防范及统计分析",
    u0130: "收集的个人信息类型",
    u0131: "OAID（开放匿名设备标识符）、VAID（开发者匿名设备标识符）、AAID（应用匿名设备标识符）",
    u0132: "收集方式",
    u0133: "SDK 集成后，在您同意隐私政策后通过接口自动读取设备系统提供的匿名标识信息",
    u0134: "第三方隐私政策",
    u0135: "http://www.msa-alliance.cn/col.jsp?id=122",
    u0136: "DCloud uni-app 开发框架 SDK",
    u0137: "第三方名称",
    u0138: "数字天堂（北京）网络技术有限公司",
    u0139: "使用目的",
    u0140: "提供应用运行基础框架、启动与隐私合规弹窗、应用更新等基础能力；配合调用设备标识 SDK 以保障应用正常运行",
    u0141: "收集的个人信息类型",
    u0142: "设备型号、操作系统版本、设备标识符（含 OAID/VAID/AAID）、网络状态、应用版本信息",
    u0143: "收集方式",
    u0144: "APP 集成 uni-app 运行框架后，在您同意隐私政策后自动初始化并采集",
    u0145: "第三方隐私政策",
    u0146: "https://dcloud.io/license/appprivacy.html",
    u0147: "微信 Open SDK",
    u0148: "第三方名称",
    u0149: "深圳市腾讯计算机系统有限公司",
    u0150: "使用目的",
    u0151: "实现微信账号登录、微信支付、微信分享功能",
    u0152: "收集的个人信息类型",
    u0153: "设备信息、网络信息、微信账号授权信息（头像、昵称等您授权的信息）",
    u0154: "收集方式",
    u0155: "您主动使用微信登录、支付或分享功能时，由 SDK 采集并传输",
    u0156: "第三方隐私政策",
    u0157: "微信隐私保护指引",
    u0158: "支付宝 SDK",
    u0159: "第三方名称",
    u0160: "支付宝（中国）网络技术有限公司",
    u0161: "使用目的",
    u0162: "实现支付宝支付功能",
    u0163: "收集的个人信息类型",
    u0164: "设备信息、网络信息、交易订单信息",
    u0165: "收集方式",
    u0166: "您主动选择支付宝支付时，由 SDK 采集并传输",
    u0167: "第三方隐私政策",
    u0168: "https://opendocs.alipay.com/common/02khjf",
    u0169: "Apple 应用内购买 SDK（仅 iOS）",
    u0170: "第三方名称",
    u0171: "Apple Inc.",
    u0172: "使用目的",
    u0173: "实现 iOS 端应用内购买与订阅功能",
    u0174: "收集的个人信息类型",
    u0175: "Apple 账号标识、交易凭证、设备信息",
    u0176: "收集方式",
    u0177: "您主动发起 iOS 内购时，由 Apple 系统 SDK 处理",
    u0178: "第三方隐私政策",
    u0179: "https://www.apple.com/legal/privacy/",
    u0180: "上述 SDK 如涉及向第三方传输个人信息，我们将督促其采用",
    u0181: "加密传输（TLS/SSL）",
    u0182: "等安全措施。如第三方 SDK 的个人信息处理规则发生变更，我们将及时更新本目录。",
    u0183: "用户同意与信息采集时机",
    u0184: "我们承诺：",
    u0185: "在您点击同意本隐私政策（含用户协议）之前，不会初始化第三方 SDK 或收集您的个人信息",
    u0186: "（法律法规另有规定的除外）。您可通过系统设置关闭相关权限，或联系我们撤回授权。",
    u0187: "实现功能或服务的数据使用",
    u0188: "当您使用{{common.appName}}中由我们的合作方提供的功能，或者由软件服务提供商、智能设备提供商、系统服务提供商与我们联合为您提供的服务时，我们可能会与其使用为实现业务目的所必需的信息。",
    u0189: "在您使用身份认证的功能或相关服务所需时，根据相关法律法规、安全保障要求可能需要完成实名认证以验证您的身份。在实名认证的过程中，与我们合作的认证服务机构需要使用您的真实姓名、手机号码。部分信息是个人敏感信息，拒绝上述使用将导致您无法完成身份认证，且可能无法获得相关服务，但不会影响开放平台其他功能的正常使用。这些信息仅供实名认证及法律法规所规定的用途，未经您的明示授权，不会用作其他目的。",
    u0190: "实现推广业务的数据使用",
    u0191: "为实现产品推广以及相关分析服务，并优化与提升推广的有效触达率，产品的推广方或提供推广以及相关分析服务的合作方可能需要使用去标识化或匿名化后的设备、网络、渠道信息以及转化数据等。",
    u0192: "推广合作方可能将上述信息与其合法获取的其他数据相结合，以优化推广效果，我们会要求其对信息的使用遵循合法、正当、必要原则，保障用户合法权利不受侵犯。",
    u0193: "实现安全与分析统计而提供信息",
    u0194: "保障使用安全：我们非常重视账号、服务及内容安全。为保障您和其他用户的账号与财产安全，使您和我们的正当合法权益免受不法侵害，我们的合作方可能会使用必要的设备、账号及日志信息。",
    u0195: "分析产品情况：为分析我们产品的使用和表现情况，我们的合作方可能需要使用该产品使用情况（崩溃、闪退）、设备标识信息、应用总体安装使用情况等信息。",
    u0196: "转移",
    u0197: "随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方继续履行个人信息处理者的义务，若继受方变更原先的处理目的、处理方式的，我们将要求继受方重新征得您的授权同意。",
    u0198: "公开",
    u0199: "我们不会公开您的个人信息，除非遵循国家法律法规规定或者获得您的同意。我们公开您的个人信息会采用符合行业内标准的安全保护措施。",
    u0200: "在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。",
    u0201: "如果我们确定您出现违反法律法规或严重违反本产品相关协议规则的情况，或为保护本产品及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或本产品相关协议规则披露关于您的个人信息，包括相关违规行为以及本产品已对您采取的措施。",
    u0202: "委托处理、共享、转让、公开披露个人信息时事先征得授权同意的例外",
    u0203: "以下情形中，委托处理、共享、转让、公开披露您的个人信息无需事先征得您的授权同意：",
    u0204: "我们履行法律法规规定的义务所必需的；",
    u0205: "与国家安全、国防安全直接相关的；",
    u0206: "维护公共安全、公共卫生、重大公共利益所必需的；",
    u0207: "刑事侦查、起诉、审判和判决执行等所必需的；",
    u0208: "出于维护您或他人的生命、财产等重大合法权益所必需但又很难得到本人授权同意的；",
    u0209: "您自行向社会公众公开的个人信息；",
    u0210: "根据个人信息主体要求签订和履行合同所必需的；",
    u0211: "从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；",
    u0212: "为开展合法的新闻报道所必需的；",
    u0213: "法律法规规定的其他情形。",
    u0214: "请您知悉：根据法律规定，委托处理、共享、转让及公开披露经匿名化处理的个人信息的，不属于个人信息的对外委托处理、共享、转让及公开披露的处理行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。",
    u0215: "四、我们如何保护您的个人信息",
    u0216: "用户的隐私和个人信息保护",
    u0217: "我们非常重视用户的隐私和个人信息保护，也会采取合理的措施保护用户的个人信息。除法律法规规定或本政策另有约定的情形外，我们将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。未经用户许可我们不会向第三方公开、透露用户个人信息，我们会对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。",
    u0218: "数据安全措施",
    u0219: "我们已采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。",
    u0220: "我们已采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。",
    u0221: "互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。",
    u0222: "在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件发生的原因、可能造成的危害、涉及个人信息的种类、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议和可采取的措施等。我们将及时将事件相关情况以电子邮件、短信、电话、发送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。请您知悉，根据可适用法律法规的规定，如采取措施能够有效避免信息泄露、篡改、丢失造成危害的，我们可以不向您进行告知。",
    u0223: "五、我们如何存储您的个人信息",
    u0224: "存储信息的地点",
    u0225: "{{common.appName}}遵守法律法规的规定，收集的有关您的信息和资料将保存在中华人民共和国境内大陆地区{{common.appName}}的服务器上。以下情形除外：",
    u0226: "法律法规有明确规定；",
    u0227: "获得您的明确授权；",
    u0228: "您通过互联网进行跨境交易等个人主动行为。",
    u0229: "存储信息的期限",
    u0230: "我们仅在为提供{{common.appName}}服务之目的所必需的期间内保留您的个人信息：例如：",
    u0231: "手机号码：当您使用手机号码注册登录时，我们需要持续保留您的手机号码，以便于向您提供正常的服务、应对您可能的查询和客诉，并保障您的账号和系统安全。",
    u0232: "您的付费充值等相关信息，在您未撤回、删除或未注销账号期间，我们会保留相关信息用于向您提供持续的业务功能。",
    u0233: "如果您注销账号、主动删除个人信息或超出必要的期限后，我们将对您的个人信息进行删除或匿名化处理，但以下情况除外：",
    u0234: "遵从法律法规有关信息留存的要求（例如：《网络安全法》规定：采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月）。",
    u0235: "出于财务、审计、争议解决等目的需要合理延长期限的。",
    u0236: "当本服务发生停止运营的情形时，{{common.appName}}将采取包括发送通知和公告形式通知您，并在法律法规要求的期限内删除服务器中留存的您的个人信息。",
    u0237: "六、您如何实现管理您个人信息的权利",
    u0238: "您的个人信息权利",
    u0239: "按照中国相关的法律、法规、标准，您在个人信息处理活动中享有若干权利，具体包括：",
    u0240: "您对个人信息处理享有知情权、决定权，有权限制或者拒绝他人对您个人信息进行处理，法律、行政法规另有规定的除外；",
    u0241: "您有权向个人信息处理者查阅、复制您的个人信息，法律另有规定情形的除外；",
    u0242: "您有权请求将您的个人信息转移至您指定的个人信息处理者；",
    u0243: "您发现您的个人信息不准确或不完整的，有权请求个人信息处理者更正、补充；",
    u0244: "您有权请求删除您的个人信息；",
    u0245: "您有权要求个人信息处理者对其个人信息处理规则进行解释说明。",
    u0246: "行使权利的方式",
    u0247: "我们保障您对自己的个人信息行使前述权利，并为您提供相关操作路径，具体地，您可以参考以下步骤进行相关操作：",
    u0248: "改变或撤回授权范围",
    u0249: "您可以在设备本身的操作系统中，关闭相机权限，改变同意范围或撤回您的授权。",
    u0250: "具体地，您可以通过以下方式进行操作：",
    u0251: "安卓：系统设置 → 应用设置 → 应用管理 → 搜索或查找{{common.appName}} → 权限管理 → 选择对应权限 → 关闭",
    u0252: "iOS：系统设置 → {{common.appName}} → 选择对应权限 → 关闭",
    u0253: "请您知悉，具体的关闭方式可能因您使用设备型号、系统版本的不同而不尽相同。请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，我们将不再收集与这些权限相关的信息，但不会影响此前基于您的授权而开展的个人信息处理。",
    u0254: "查阅、复制、更正、补充、删除您的个人信息",
    u0255: "您可以通过如下方式查阅、复制、更正、补充或删除您的个人信息：",
    u0256: "查阅/更正/补充账号信息：点击头像账号区域，进行操作",
    u0257: "查阅/删除历史对话：展开对话框左侧 → 选择历史对话 → 删除，或点击头像账号区域 → 选择“删除所有对话”",
    u0258: "复制/修改历史对话：选择对话框内的输入内容 → 复制/修改",
    u0260: "由于应用版本的升级和功能的变动，上述具体的操作步骤可能不同，以应用内实际的操作步骤为准。除上述外，如果您或其他有权主体对相关法律法规赋予您的个人信息权利的行使，有任何主张、要求或者疑问，您可以通过第十六节列明的联系方式与我们联系，我们将尽快审核所涉问题，并在验证您的用户身份后的十五个工作日内回复。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，{{common.appName}}可能会予以拒绝。",
    u0261: "逝者的个人信息保护",
    u0262: "我们会持续确保我们的用户信息安全无虞。若{{common.appName}}的用户不幸去世，其近亲属（以下简称“逝者近亲属”）为了自身的合法、正当利益，可通过第十六节列明的方式，与我们取得联系，在不违反逝者生前安排且不侵害他人和公众正当利益的前提下，对逝者的相应个人信息行使查阅、复制、更正、删除等权利。为了充分保护逝者的个人信息权益，申请行使该等权利的逝者近亲属需要完成身份核验手续，并承诺和保证逝者近亲属行使该等权利不违背逝者生前的安排，且行使权利的目的具有合法正当性。",
    u0263: "注销账号",
    u0264: "您有权根据《{{common.appName}}注销须知》注销您的账号，您可以通过“主页” → “个人信息” → “注销账号”或根据第十六节列明的方式联系我们进行账号注销。在您注销账号前，我们将验证您的个人身份、安全状态、财产结清情况、设备信息等。我们将会在收到您的申请后及时进行处理，并在十五个工作日或法律法规要求的时限内回复您的请求。您知悉并理解，注销账号的行为是不可逆的行为，当您注销账号后，我们将删除有关您的相关信息或进行匿名化处理，但法律法规及相关国家标准另有规定的除外。",
    u0265: "七、我们如何保护未成年人的个人信息",
    u0266: "{{common.appName}}主要服务成年人，但我们依然非常重视对未成年人个人信息的保护。",
    u0267: "若您是未满18周岁的未成年人，在使用本产品及相关服务前，请在您的父母或其他监护人的监护、指导下共同阅读并同意本隐私政策。我们不会主动收集未满14周岁的未成年人（儿童）的个人信息。如果我们发现或接到反馈，在未事先获得监护人同意的情况下自动收集了儿童的个人信息，则会设法尽快删除相关信息。",
    u0268: "若您是未成年人的父母或监护人，如您对本政策所述相关事宜有任何疑问、意见、建议或投诉、举报需求，请通过第十六节列明的方式与我们进行反馈。",
    u0269: "八、服务内容",
    u0270: "1.1",
    u0271: " 我们的产品及服务包括我们以网站、应用程序（可能含不同版本）、小程序、供第三方网站和应用程序使用的软件开发工具包（SDK）、应用程序编程接口（API）以及随技术发展出现的创新形态方式向您提供的产品与服务，包括但不限于以生成式人工智能服务为核心功能以及其他功能的平台（以下称“{{common.appName}}”或“本服务”）。",
    u0272: "1.2",
    u0273: " 我们提供的生成式人工智能产品和服务以Chat大语言模型为基础。Chat大语言模型基于深度神经网络算法，依次经过大规模自监督学习的预训练以及针对性的优化训练等阶段开发而成，该模型可以通过对输入信息（包括文本、图片、文件等）进行编码和计算来预测下一个词元，从而具备文本生成和对话等能力，其能够熟练执行基于文本生成的广泛的不同任务，并可以集成到各种下游系统或应用中。具体到{{common.appName}}产品服务中，模型基于用户输入信息（以下称“输入”），通过计算推理输出相应的内容作为响应（以下称“输出”、“生成内容”），包括文字、表格和代码等。用户可对输出进行评价，包括点赞、踩等操作，以反馈用户对{{common.appName}}输出信息的意见。Chat模型信息如下：",
    u0274: "平台",
    u0275: "模型",
    u0276: "微软",
    u0277: "gpt-3.5-turbo",
    u0278: "文心一言",
    u0279: "ERNIE-4.5-TURBO-32k",
    u0280: "豆包",
    u0281: "Doubao-1.5-pro-32k",
    u0282: "智谱AI",
    u0283: "GLM-4.5-Flash",
    u0284: "MiniMax",
    u0285: "MiniMax-Text-01",
    u0286: "DeepSeek",
    u0287: "Deepseek-chat",
    u0288: "讯飞星火",
    u0289: "lite",
    u0290: "通义千问",
    u0291: "Qwen-plus",
    u0292: "1.3",
    u0293: " 随着生成式人工智能的技术、模型和产品的不断迭代发展以及法律、法规的变化，我们可能对服务进行新增、升级、变更、中止或终止，或对服务的技术、方式、性能等进行必要的调整，并可能针对新增服务功能开展内部或外部测试。",
    u0294: "1.4",
    u0295: " 我们将采取不低于行业实践的必要措施，保障平台的网络安全和稳定运行，并努力提升和改进技术，保障您的产品和服务使用体验。如您对我们的服务有任何问题或反馈，可通过第十六节列明的方式与我们联系。",
    u0296: "九、账号管理",
    u0297: "2.1",
    u0298: " 本服务主要面向成年人。若您未满18周岁，请在监护人陪同下阅读本文件并取得同意后使用；未成年人个人信息保护规则详见",
    u0299: "第七节",
    u0300: "。",
    u0301: "2.2",
    u0302: " 您在使用本服务前，应根据页面通过手机号码或第三方账号注册账号，按要求填写真实、准确、合法、有效的相关信息，并确认同意本协议以及其他相关规则、政策。若您提交的材料或提供的信息不准确、不真实、不规范或公司有理由怀疑为错误、不实、不合法的资料，则我们有权拒绝为您提供相关功能，您可能无法使用本软件及相关服务或在使用过程中部分功能受到限制。您的账号是您登录及使用本服务的凭证，该账号不可转让、不可赠与、不可继承。",
    u0303: "2.3",
    u0304: " 在您注册和使用账号时，您须承诺和保证：",
    u0305: "对注册信息的真实性、合法性、有效性承担全部责任，及时更新注册信息，不得冒用他人的名义注册账号或使用本服务；",
    u0306: "妥善保管账号及密码，并对该账号项下的所有行为承担法律责任；",
    u0307: "不得恶意注册账号，包括但不限于频繁注册、批量注册等行为；",
    u0308: "不得以任何形式将账号转让、出借、出租或提供给他人使用。",
    u0309: "2.4",
    u0310: " 如您丢失账号、遗忘密码或泄露验证码，您可及时申诉请求找回。我们特别提醒您应妥善保管您的账号、密码及验证码。当您使用完毕后，应安全退出。对于用户因账号或密码泄露造成的各种损失，您将自行承担相应责任。用户发现任何非法使用用户账号的情况，应立即通知我们，我们将给予最大限度地配合和处理。",
    u0311: "2.5",
    u0312: " 如用户向我们提出注销账户，经我们审核同意，由我们注销该注册用户，用户即解除与我们的合同关系。但用户注销账号后，我们仍有权：",
    u0313: "按照法律法规的要求，保留该用户的注册数据及以前的行为记录；",
    u0314: "对用户在注销前在使用本服务过程中存在违法行为或违反本协议的行为，行使本协议所约定的权利。",
    u0315: "十、使用规范",
    u0316: "3.1",
    u0317: " 您充分理解并同意，依据本协议，我们授予您一项可撤销的、不可转让的和非独占地的合法使用本产品及相关服务的权利。本协议未明示授权的其他一切权利仍由{{common.appName}}保留，您在行使该些权利前须另行获得{{common.appName}}的书面许可，同时{{common.appName}}如未行使前述任何权利，并不构成对该权利的放弃。如果您对外发布或传播本服务生成的输出，您应当：",
    u0318: "主动核查输出内容的真实性、准确性，避免传播虚假信息；",
    u0319: "以显著方式标明该输出内容系由人工智能生成，以向公众提示内容合成的情况；",
    u0320: "避免发布和传播任何违反本协议使用规范的输出内容。",
    u0321: "3.2",
    u0322: " 您在使用我们提供的上述服务时，应遵守法律法规的要求和本协议的约定，遵守自愿、平等、公平及诚实信用原则，不利用本服务侵犯他人合法权益及谋取不正当利益，不扰乱互联网平台正常秩序。",
    u0323: "3.3",
    u0324: " 作为本服务的使用者，您不得违反《互联网信息服务管理办法》《网络信息内容生态治理规定》《生成式人工智能服务管理暂行办法》等法律法规以及相关标准关于网络信息内容安全的要求，不得输入、利用本服务输出或传播以下违法不良信息：",
    u0325: "反对宪法所确定的基本原则的；",
    u0326: "危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；",
    u0327: "损害国家荣誉和利益的；",
    u0328: "歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；",
    u0329: "宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；",
    u0330: "煽动民族仇恨、民族歧视，破坏民族团结的；",
    u0331: "破坏国家宗教政策，宣扬邪教和封建迷信的；",
    u0332: "散布谣言，扰乱经济秩序和社会秩序的；",
    u0333: "散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；",
    u0334: "侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；",
    u0335: "法律、行政法规禁止的其他内容。",
    u0336: "3.4",
    u0337: " 为履行法定义务的要求，{{common.appName}}有权采取技术手段等措施对用户使用本服务的行为及信息进行审查，包括但不限于对输入和输出进行审查、建立风险过滤机制、建立违法内容特征库等。作为本服务的使用者，您不得通过以下方式恶意对抗本服务的信息内容安全管理和风险防范机制，包括但不限于：",
    u0338: "恶意对抗行为，包括但不限于使用变体、乱码、字符、谐音等方式规避服务检测来输入或生成违反上述3.3的言论；",
    u0339: "通过假扮身份、反向诱导、越狱攻击等方式进行恶意攻击、诱导和投毒；",
    u0340: "未经{{common.appName}}同意或未有合法正当依据，擅自去除、篡改本服务涉及的生成内容标识。",
    u0341: "3.5",
    u0342: " 作为本服务的使用者，您不得违反《网络安全法》《数据安全法》等法律法规以及相关标准的要求，不得对本服务以及支持本服务正常运行的系统、网络、模型以及其他组件等进行干扰、破坏或攻击，不得从事以下危害本服务安全的活动：",
    u0343: "从事非法侵入网络的活动，例如：使用未经许可的数据或进入未经许可的服务器/账号；伪造TCP/IP数据包名称或部分名称；未经许可，企图探查、扫描、测试本软件系统或网络的弱点等；",
    u0344: "从事干扰、破坏网络正常功能的活动，例如：故意生成、传播恶意程序或病毒；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；以导致计算机系统或设施承受不合理负载的方式干扰运营等；",
    u0345: "从事窃取网络数据的活动，例如：对本软件及相关服务进行反向工程、反向汇编、反向编译、翻译或者以其他方式尝试发现本软件的源代码、模型、算法和系统的源代码或底层组件；以任何方式（包括但不限于通过任何机器人、爬虫、其他自动设置、设置镜像）来抓取、复制本服务及其所包含的任何内容等；",
    u0346: "从事其他危害本服务系统、网络、模型以及其他组件安全的活动。",
    u0347: "3.6",
    u0348: " 作为本服务的使用者，您不得利用本服务用于以下不当目的：",
    u0349: "将本服务用于任何违反法律法规、监管政策或侵犯第三方合法权益的非法目的；",
    u0350: "将本服务用于可能对人身健康、心理、社会或经济等产生严重有害影响或违反科技伦理的危险目的；",
    u0351: "从事侵犯知识产权、商业秘密以及其他违反商业道德的行为，或利用算法、数据、平台等优势，实施垄断和不正当竞争行为；",
    u0352: "未经{{common.appName}}授权，将服务的全部或部分进行复制、转让、出租、出借、出售或提供分许可、转许可；",
    u0353: "其他法律、行政法规所禁止、限制的，或可能损害{{common.appName}}利益的使用方式。",
    u0354: "十一、输入与输出",
    u0355: "4.1",
    u0356: " 您对提交给我们服务的所有输入和对应的输出负责。您声明并保证您向我们的服务提交的输入，您拥有根据我们的条款处理输入所需的所有权利、许可和权限，这些输入和对应的输出不侵犯任何人的知识产权、肖像权、名誉权、荣誉权、姓名权、隐私权、个人信息权益等合法权益，不涉及任何国家秘密、商业秘密或其他可能会对国家安全或者公共利益造成不利影响的数据。",
    u0357: "4.2",
    u0358: " 在符合法律规定和我们的条款的条件下，您对本服务的输入与输出享有以下权利：",
    u0359: "您保留在提交的输入中拥有的任何权利、所有权和利益（如有）；",
    u0360: "我们将本服务输出的内容的任何权利、所有权和利益（如有）归属于您；",
    u0361: "您可将本服务的输入与输出应用于广泛的使用场景中，包括个人使用、学术研究、衍生产品开发、训练其他模型（如模型蒸馏）等。",
    u0362: "4.3",
    u0363: " 本服务提供的所有输出均由人工智能模型答复，可能出现错误或遗漏，仅供您参考，您不应将输出的内容作为专业建议。特别的，当您在使用本服务咨询医疗、法律、金融及其他专业问题时，请注意本服务不构成任何建议或承诺，不代表任何专业领域的意见。若您需要相关专业服务，应咨询专业人士，并在专业人士的指导下作出决策。本软件的输出不应成为您进一步作为或不作为的依据。您根据输出的内容所作出的任何判断或者据此作出的后续相关操作行为，所带来的后果和责任均由您自行承担，包括因对输出的内容的真实性、准确性、可靠性、不侵权或满足特定目的的依赖而产生的风险。您应科学理性认识和依法使用生成式人工智能技术。",
    u0364: "4.4 个人信息处理规则",
    u0365: "您理解并同意，我们在提供本服务过程中可能涉及对您个人信息的处理。处理目的、方式、信息类型、保存期限、您的权利及第三方共享等规则，以本文件",
    u0366: "「个人信息处理总则」及第一至七节",
    u0367: "为准；其中第三方 SDK 收集使用规则详见",
    u0368: "第三节",
    u0369: "。如您对个人信息处理有疑问或需拒绝模型训练等特定用途，可通过",
    u0370: "第十六节",
    u0371: "列明方式联系我们。",
    u0372: "4.5",
    u0373: " 为履行法律法规所规定的要求以及提供本协议约定的服务，您知悉并授权，在符合第4.4条所述个人信息处理规则的前提下，我们可能会将服务所收集的输入及对应输出（经安全加密技术处理、严格去标识化且无法重新识别特定个人）用于本协议下服务的优化以及统计分析、问题排查、安全风控等目的。如您拒绝我们按照上述方式处理数据，可以通过第十六节列明的联系方式向我们反馈。",
    u0374: "十二、知识产权和其他权利",
    u0375: "5.1",
    u0376: " {{common.companyName}}为本服务的开发、运营主体，对本服务（包括但不限于软件、技术、程序、代码、模型权重、用户界面、网页、文字、图表、版面设计、商标、电子文档等）享有法律法规允许范围内的全部权利（包括但不限于著作权、商标权、专利权和其他知识产权），但相关权利人依照法律规定或本协议的约定应享有权利（如输入与输出）的除外。",
    u0377: "5.2",
    u0378: " 未经我们许可，请不要擅自使用本产品相关的包括但不限于“{{common.appName}}”等在内的任何商标、服务标记、商号、域名、网站名称、公司徽标 (LOGO)、URL或其他显著品牌特征等，不得将本条款前述标识以单独或结合任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理该些标识的行为。",
    u0379: "十三、违约责任与责任限制",
    u0380: "7.1",
    u0381: " 针对您违反本协议或其他服务条款的行为，我们有权独立判断，无需通知对您采取警示提醒、限期改正、限制账号功能、暂停使用、关闭账号、禁止重新注册、删除相关内容等处置措施。我们有权公告处理结果，且有权根据实际情况决定是否恢复使用。对涉嫌违反法律法规、涉嫌违法犯罪的行为将保存有关记录，并依法向有关主管部门报告、配合有关主管部门调查。由此而导致或产生的法律责任或第三方主张的任何索赔、要求或损失，您应当自行承担责任；因此给我们造成任何损失的，您也应当一并赔偿（包括我们维权所支出的诉讼费、仲裁费、律师费、公证费、公告费、鉴定费、差旅费、调查取证费、赔偿金、违约金、和解费用、行政处罚的罚金等）。",
    u0382: "7.2",
    u0383: " 我们致力于提供安全、稳定、持续的服务，保障用户正常使用，但本服务仅以“现状”、“当前功能”的状态提供。尽管我们已经尽了最大努力，但是由于本服务所依赖的技术本身存在的技术瓶颈和科技客观限制，我们不能对以下事项作出任何保证，具体如下：",
    u0384: "不保证本服务在操作上不会中断、没有错误、不受干扰、持续稳定或不存在任何故障；",
    u0385: "不保证在现有技术水平下有能力纠正本服务的所有缺陷；",
    u0386: "限于技术特性，不保证本服务生成内容的合法性、真实性、完整性、准确性、及时性及实用性，不排除通过提示词恶意诱导等违反本协议的使用方式/目的可能输出的包含与本服务运营主体观点不一致的内容；",
    u0387: "本服务的输入和输出虽已经过过滤审查，但仍不排除无法发现您的输入或本服务输出中存在违规问题，不排除其中部分信息具有瑕疵、存在虚假内容或存在不合理、引发用户不适的地方；",
    u0388: "由于人工智能模型的特性，就相同的上传至本服务平台的内容（包括但不限于作为提示词的文本或其他一切用于协助产生人工智能生成内容的提示性内容），本服务可能生成不同的内容结果；",
    u0389: "不保证本服务能满足用户的所有要求；",
    u0390: "当本服务提供的内容包含来自插件、第三方网站等内容时，我们并不对这些内容的有效性负责，且不保证从这些途径获取的任何内容、产品、服务或其他材料的真实性、合法性、安全性。",
    u0391: "7.3",
    u0392: " 不论在何种情况下，本服务均不对由于网络连接故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，火灾，洪水，风暴，爆炸，不可抗力，战争，政府行为，国际、国内法院的命令，黑客攻击，互联网病毒，网络运营商技术调整，政府临时管制或任何其他不能合理控制的原因而造成的本服务不能访问、服务中断、信息及数据的泄露、延误、停滞或错误，不能提供或延迟提供服务而承担责任。",
    u0393: "7.4",
    u0394: " 我们可能会不时推出新的功能，我们提示您，在新功能测试期可能存在服务不稳定等情况，除法律有明确规定外，我们无法也不对处于测试期的功能服务的稳定性等进行保证。",
    u0395: "十四、法律适用和管辖",
    u0396: "8.1",
    u0397: " 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国大陆地区法律。",
    u0398: "8.2",
    u0399: " 本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成，任何一方均有权向{{common.companyName}}住所地有管辖权的法院起诉。",
    u0400: "十五、本文件如何更新",
    u0401: "为向您提供更好的服务，我们可能因法律法规、政策调整、技术条件或产品功能变化，适时修订本文件（包括隐私政策与用户协议相关条款）。修订内容构成本文件的组成部分。",
    u0402: "更新后，我们将在{{common.appName}}官方网站或应用内以公告等方式发布最新版本，请您及时查阅。",
    u0403: "若您不同意修订内容，可停止使用本服务或注销账号；您继续使用即视为接受修订后的内容。停止使用或注销前已发生的行为，仍受当时有效版本约束。",
    u0404: "对会导致您个人信息相关权益实质减损的重大变更，我们将通过电子邮件、短信或页面显著提示等方式另行告知。",
    u0405: "十六、如何联系我们",
    u0406: "如您对本文件、个人信息处理、账号与服务使用有任何疑问、意见、建议、投诉、申诉或举报，可通过以下方式联系我们：",
    u0407: "应用内反馈：登录产品界面 → 点击「联系我们」",
    u0408: "联系邮箱：{{common.contactEmail}}",
    u0409: "联系地址：{{common.contactAddress}}",
    u0410: "运营主体：{{common.companyName}}",
    u0411: "涉及知识产权侵权、违法信息或违反本文件约定的使用行为，您亦可通过上述渠道如实反馈，我们将依法处理。",
    u0412: "我们可能需您提供有效联系方式、书面请求及相关证明材料；我们将在验证身份后处理，并于",
    u0413: "十五个工作日内",
    u0414: "回复。对于无端重复、需过多技术投入或可能损害他人合法权益的请求，我们可能不予受理。",
  }
}
